import React from 'react';
import SideMenu, { SideMenuTitle, SideMenuLink } from '@amzn/meridian/side-menu';
import Row from '@amzn/meridian/row';
import Heading from '@amzn/meridian/heading';
import Icon from '@amzn/meridian/icon';
import arrowsUpAndDownTokens from '@amzn/meridian-tokens/base/icon/arrows-up-and-down';
import * as AppRoutes from 'src/routing/constants/routes';
import * as AppStrings from 'src/localization/string-ids/app-strings';
import { Icons } from 'src/constants/general-media';
import { usePageChrome } from 'src/components/app/page-chrome/PageChrome';
import './SideNav.scss';

interface SideNavStateProps {
    openSideMenu: boolean;
    accessibleTools: string[];
}

interface SideNavDispatchProps {
    updateOpenSideMenu: (openSideMenu: boolean) => void;
}

type Props = SideNavStateProps & SideNavDispatchProps & {
    // The page fits the menu to the smallest screens
    compact?: boolean;
};

export class SideNav extends React.Component<Props> {

    private SORT = "Sort";

    private shouldToolBeVisible = (toolName: string): boolean => {
        return this.props.accessibleTools.includes(toolName);
    }

    public render() {
        return(
            <Row alignmentVertical={"stretch"}>
                {/* On a compact page: 340px is Meridian's default; 85vw, a chosen share, keeps the close button
                    on the WS501's 230px screen (unverified) */}
                <SideMenu open={this.props.openSideMenu} onClose={() => this.props.updateOpenSideMenu(false)}
                          type={"overlay"} maxWidth={this.props.compact ? "min(340px, 85vw)" : undefined}>
                    <SideMenuTitle>
                        <div className="side-nav-header">
                            <img src={Icons.RIV_ICON_SMALL} alt="" className="riv-small-logo"/>
                            <Heading level={6} type={"h50"}>{AppStrings.RIV_TITLE}</Heading>
                        </div>
                    </SideMenuTitle>
                    {this.shouldToolBeVisible(this.SORT) &&
                        <SideMenuLink
                            href={AppRoutes.SUB_SORT_PAGE_ROUTE}
                            selected={true}
                        >
                            <Icon tokens={arrowsUpAndDownTokens} />
                            <span className="side-nav-list-option">{AppStrings.SIDE_NAV_ITEM_SORT}</span>
                        </SideMenuLink>
                    }
                </SideMenu>
            </Row>
        );
    }
}

const SideNavOnPage = (props: Omit<Props, 'compact'>) => <SideNav {...props} compact={usePageChrome().compact}/>;

export default SideNavOnPage;